import { render, staticRenderFns } from "./ScratchJrIframe.vue?vue&type=template&id=2234bb96&scoped=true&"
import script from "./ScratchJrIframe.vue?vue&type=script&lang=js&"
export * from "./ScratchJrIframe.vue?vue&type=script&lang=js&"
import style0 from "./ScratchJrIframe.vue?vue&type=style&index=0&id=2234bb96&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2234bb96",
  null
  
)

export default component.exports